/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { euiShadowFlat, euiShadow, euiSlightShadowHover, euiShadowXSmall, euiShadowSmall, euiShadowMedium, euiShadowLarge, euiShadowXLarge } from '@elastic/eui-theme-common';
import { useEuiTheme } from '../../services/theme';
export { euiShadowFlat, euiShadow, euiSlightShadowHover, euiShadowXSmall, euiShadowSmall, euiShadowMedium, euiShadowLarge, euiShadowXLarge };
export var useEuiSlightShadowHover = function useEuiSlightShadowHover(options) {
  var euiThemeContext = useEuiTheme();
  return euiSlightShadowHover(euiThemeContext, options);
};
export var useEuiShadowFlat = function useEuiShadowFlat(options) {
  var euiThemeContext = useEuiTheme();
  return euiShadowFlat(euiThemeContext, options);
};
export var useEuiShadow = function useEuiShadow() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'l';
  var options = arguments.length > 1 ? arguments[1] : undefined;
  var euiThemeContext = useEuiTheme();
  return euiShadow(euiThemeContext, size, options);
};